import { api } from './api'
import {
  PatientReportRequest,
  AggregateReportRequest,
  QueryReportRequest,
  ReportFormatInfo,
  MeasurementAnalysisReportRequest,
} from '../types/report'

/**
 * Report Service
 * Handles report generation and export
 */
export const reportService = {
  /**
   * Get available export formats
   */
  getFormats: async (): Promise<ReportFormatInfo[]> => {
    const response = await api.get<{ formats: ReportFormatInfo[] }>('/reports/formats')
    return response.data.formats
  },

  /**
   * Generate patient record report
   */
  generatePatientReport: async (request: PatientReportRequest): Promise<Blob> => {
    const response = await api.post('/reports/patient', request, {
      responseType: 'blob',
    })
    return response.data as Blob
  },

  /**
   * Generate aggregate report
   */
  generateAggregateReport: async (request: AggregateReportRequest): Promise<Blob> => {
    const response = await api.post('/reports/aggregate', request, {
      responseType: 'blob',
    })
    return response.data as Blob
  },

  /**
   * Generate measurement/analysis report
   */
  generateMeasurementAnalysisReport: async (request: MeasurementAnalysisReportRequest): Promise<Blob> => {
    const response = await api.post('/reports/measurement-analysis', request, {
      responseType: 'blob',
    })
    return response.data as Blob
  },

  /**
   * Execute ad-hoc query
   */
  queryData: async (request: QueryReportRequest): Promise<Blob> => {
    const params = new URLSearchParams()
    params.append('table', request.table)
    if (request.patientId) params.append('patientId', request.patientId)
    if (request.startDate) params.append('startDate', request.startDate)
    if (request.endDate) params.append('endDate', request.endDate)
    if (request.format) params.append('format', request.format)

    const response = await api.get(`/reports/query?${params.toString()}`, {
      responseType: 'blob',
    })
    return response.data as Blob
  },

  /**
   * Download report as file
   */
  downloadReport: (blob: Blob, filename: string): void => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  },
}
